<template>
  <div class="main-head">
    <div class="logos">
      <Logo />

      <Hacienda />
    </div>

    <div class="middle">
      <!-- <Search /> -->

      <RedesSociales />
      <LogOut />
    </div>

    <div class="menu">
      <Menu />
    </div>
  </div>
</template>

<script>
import Logo from "../../image/navbar/Logo.vue";
import Hacienda from "../../image/navbar/Hacienda.vue";
// import Search from "../../input/Search.vue";
import RedesSociales from "../../button/redes/RedesSociales.vue";
import Menu from "../menu/Menu.vue";
import LogOut from "@/views/gestion/components/Nav.vue"
export default {
  components: {
    Hacienda,
    Logo,
    // Search,
    RedesSociales,
    LogOut,
    Menu,
  },
};
</script>

<style scoped>
.main-head {
  display: flex;
  justify-content: space-between;
  margin: 0 50px;
  align-items: center;
}

.logos {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.middle {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.menu {
  display: none;
}

@media screen and (max-width: 874px) {
  .middle {
    display: none;
  }

  .menu {
    display: initial;
    text-align: end;
  }
}

@media screen and (max-width: 343px) {
  .img {
    margin-left: -6px;
    margin-top: 5px;
    margin-right: -20px;
  }
}
</style>
